import React, {useState} from 'react';
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { navigate } from "@reach/router"
import db from '../firebase'

const UpdatePost = (props) => {

    const [title, setTitle] = useState('')
    const [content, setContent] = useState('')
    
    const onTitleChange = (event) =>{setTitle(event.target.value)}
    const onContentChange = (event) =>{setContent(event.target.value)}
    const onCreatePost = () =>{
        let postdef = db.collection('Posts')
        let payload = {title, content}

        postdef.add(payload)
            .then(function(doc) {
                console.log("Document Uploaded successfully!", doc.id)
            })
        setTitle('')
        setContent('')
        navigate('/Posts')
    }
    
    

    return(
        <div className="create_post_container">
            <div className="page_header_container">
                <h1>CreatePost</h1>
                <hr />
            </div>
            <div className="post_inputs_container">
                <div className="post_input_container">
                  
                    <Form>
                        <Form.Group controlId="create_post_title">
                            <Form.Label>Post Title</Form.Label>
                            <Form.Control type="text" placeholder="Post Title" value={title} onChange={onTitleChange} />
                        </Form.Group>
                        <Form.Group controlId="create_post_content">
                            <Form.Label>Post Content</Form.Label>
                            <Form.Control as="textarea" rows="9" value={content} onChange={onContentChange}/>
                        </Form.Group>
                        <Button variant="primary" onClick={onCreatePost} >
                            Submit
                        </Button>
                    </Form>             

                </div>                
            </div>
        </div>
    )
}

export default UpdatePost;